import { DeviceMobile } from "phosphor-react"
import { AppText } from "~/ui/app-text"

export const UnsupportedAttachment = () => (
  <div className="flex w-full items-center gap-3 rounded-xl bg-neutral-200 p-3">
    <DeviceMobile size={20} className="shrink-0 text-base-gray" />
    <AppText variant="body3-medium" className="text-base-gray">
      Download the app to view
    </AppText>
  </div>
)
